import React from 'react';

import { InstallableAppCardList } from 'client/blocks-redesign/AppCardList/InstallableAppCardList';
import { SkillsCardList } from 'client/blocks-redesign/AppCardList/SkillsCardList';
import { IndexLayout } from 'client/blocks-redesign/Layout/Layout';
import { WithAppsMetaInfo, withAppsMetaInfo } from 'client/context/appsMetaInfoContext';
import { Channel } from 'client/model/skill';
import { isInstallableAppChannel } from 'client/utils';

import styles from './AppsIndex.module.scss';
import { AppsIndexNavbar } from './AppsIndexNavbar';

interface InstallableAppsIndexProps {
    channel: Channel;
}

const AppsIndex = ({ channel }: InstallableAppsIndexProps & WithAppsMetaInfo) => {
    return (
        <IndexLayout>
            <article className={styles.appsIndex__container}>
                <AppsIndexNavbar channel={channel} />
                {isInstallableAppChannel(channel) ? (
                    <InstallableAppCardList channel={channel} />
                ) : (
                    <SkillsCardList channel={channel} />
                )}
            </article>
        </IndexLayout>
    );
};

export default withAppsMetaInfo(AppsIndex);
